var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_304_65",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-05H40V40H0V1.90735e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_304_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2709 9.29576V3.2917H10.7291V9.29576C10.7291 13.5065 13.5366 17.0611 17.3816 18.191C18.183 18.4265 18.7344 19.1602 18.7344 19.9954V19.9964C18.7344 20.8315 18.183 21.5653 17.3816 21.8007C13.5366 22.9306 10.7291 26.4851 10.7291 30.696V36.9167H29.2709V30.696C29.2709 26.4847 26.4629 22.9298 22.617 21.8004C21.8155 21.565 21.2641 20.8311 21.2641 19.9958C21.2641 19.1606 21.8155 18.4268 22.617 18.1914C26.4629 17.0619 29.2709 13.507 29.2709 9.29576Z",
    fill: "#DDFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.617 18.1914C26.4629 17.0619 29.2709 13.507 29.2709 9.29574V3.29168H26.5941V9.29574C26.5941 13.507 25.1987 17.0619 21.3529 18.1914C20.5516 18.4268 20 19.1605 20 19.9959C20 20.8311 20.5516 21.565 21.3529 21.8003C25.1987 22.9297 26.5941 26.4846 26.5941 30.696V36.9167H29.2709V30.696C29.2709 26.4846 26.4629 22.9297 22.617 21.8003C21.8155 21.565 21.2641 20.8311 21.2641 19.9959C21.2641 19.1605 21.8155 18.4268 22.617 18.1914Z",
    fill: "#98EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9386 3.85339H11.0614C9.715 3.85339 8.6236 2.76191 8.6236 1.41558V0.581755H31.3764V1.41558C31.3764 2.76191 30.2849 3.85339 28.9386 3.85339Z",
    fill: "#F99864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2211 0.581755V1.41558C26.2211 2.76191 25.1296 3.85339 23.7833 3.85339H28.9386C30.285 3.85339 31.3764 2.76191 31.3764 1.41558V0.581755H26.2211Z",
    fill: "#EE722F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 36.1383H28.9386C30.285 36.1383 31.3764 37.2298 31.3764 38.5761V39.4099H8.6236V38.5761C8.6236 37.2298 9.71508 36.1383 11.0614 36.1383Z",
    fill: "#F99864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9386 36.1383H24.5078C25.8542 36.1383 26.9457 37.2297 26.9457 38.5761V39.4099H31.3764V38.5761C31.3764 37.2297 30.2849 36.1383 28.9386 36.1383Z",
    fill: "#EE722F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.3203C16.1639 16.3203 13.0543 13.2107 13.0543 9.3748V9.40535C13.7085 9.68597 14.7509 10.0348 16.0205 10.0002C19.6342 9.90167 21.2584 6.80136 23.8971 7.198C24.6672 7.31378 26.7856 7.98722 26.9457 9.40535C26.9446 9.39519 26.9457 9.38496 26.9457 9.3748C26.9457 13.2107 23.836 16.3203 20 16.3203Z",
    fill: "#FFBA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32.2948C22.1226 32.2948 23.8434 34.0156 23.8434 36.1383V36.1213H16.1566V36.1383C16.1566 34.0156 17.8773 32.2948 20 32.2948Z",
    fill: "#FFBA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9386 3.85339H11.0614C9.715 3.85339 8.6236 2.76191 8.6236 1.41558V0.581755H31.3764V1.41558C31.3764 2.76191 30.2849 3.85339 28.9386 3.85339Z",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0614 36.1383H28.9386C30.285 36.1383 31.3764 37.2298 31.3764 38.5761V39.4099H8.6236V38.5761C8.6236 37.2298 9.71508 36.1383 11.0614 36.1383Z",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2709 32.4802V30.696C29.2709 26.4847 26.4629 22.9298 22.617 21.8003C21.8155 21.565 21.2641 20.8312 21.2641 19.9958C21.2641 19.1606 21.8155 18.4268 22.617 18.1914C26.4629 17.0619 29.2709 13.5071 29.2709 9.29574V3.8534H10.7291V9.29574C10.7291 13.5066 13.5366 17.0611 17.3816 18.191C18.183 18.4264 18.7344 19.1602 18.7344 19.9953V19.9964C18.7344 20.8315 18.183 21.5653 17.3816 21.8007C13.5366 22.9307 10.7291 26.4852 10.7291 30.696V36.1383H29.2709V34.8843",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3391 11.3498C13.1537 10.7238 13.0543 10.0609 13.0543 9.3748V9.40535C13.7085 9.68597 14.7508 10.0348 16.0205 10.0002C19.6342 9.90167 21.2584 6.80136 23.8971 7.198C24.6672 7.31378 26.7856 7.98722 26.9457 9.40535C26.9445 9.39519 26.9457 9.38496 26.9457 9.3748C26.9457 13.2107 23.8359 16.3203 20 16.3203C17.7838 16.3203 15.81 15.2825 14.5382 13.6661",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32.2948C22.1226 32.2948 23.8434 34.0156 23.8434 36.1383V36.1213H16.1566V36.1383C16.1566 34.0156 17.8773 32.2948 20 32.2948Z",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.3203V17.8983",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.3715V23.381",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 25.5117V25.731",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29.5555V32.2533",
    stroke: "#181920",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand_clock.841af6b76c4b870a14646ac7b9fcef6d.svg";
export { ForwardRef as ReactComponent };